export var FunIdEnvType;
(function (FunIdEnvType) {
    FunIdEnvType["Development"] = "dev";
    FunIdEnvType["Production"] = "prod";
})(FunIdEnvType || (FunIdEnvType = {}));
export class FundEnvService {
    constructor() {
        this.storageKey = 'funid_env';
    }
    getEnvType() {
        return localStorage.getItem(this.storageKey);
    }
    isValidEnv(name) {
        return (name === FunIdEnvType.Development || name === FunIdEnvType.Production);
    }
    hasSpecifiedEnv() {
        return Boolean(localStorage.getItem(this.storageKey));
    }
}
//# sourceMappingURL=funid-env-service.js.map